const apiKey = '57240db50c2008e78c261e1a934627e4';
const baseUrl = 'https://api.themoviedb.org/3';

// ===== TRENDING =====
export const fetchTrendingMovies = async () => {
  try {
    const response = await fetch(`${baseUrl}/trending/movie/week?api_key=${apiKey}`);
    if (!response.ok) throw new Error('Failed to fetch trending movies');
    return await response.json();
  } catch (error) {
    console.error('Error fetching trending movies:', error);
    return { results: [] };
  }
};

export const fetchTrendingSeries = async () => {
  try {
    const response = await fetch(`${baseUrl}/trending/tv/week?api_key=${apiKey}`);
    if (!response.ok) throw new Error('Failed to fetch trending series');
    return await response.json();
  } catch (error) {
    console.error('Error fetching trending series:', error);
    return { results: [] };
  }
};

// ===== DETAILS / CREDITS / VIDEOS =====
export const fetchMovieDetails = async (movieId) => {
  try {
    const response = await fetch(`${baseUrl}/movie/${movieId}?api_key=${apiKey}&language=en-US`);
    if (!response.ok) throw new Error('Failed to fetch movie details');
    return await response.json();
  } catch (error) {
    console.error('Error fetching movie details:', error);
    return null;
  }
};

export const fetchContentDetails = async (type, id) => {
  try {
    const response = await fetch(`${baseUrl}/${type}/${id}?api_key=${apiKey}&language=en-US`);
    if (!response.ok) throw new Error('Failed to fetch content details');
    return await response.json();
  } catch (error) {
    console.error('Error fetching content details:', error);
    return null;
  }
};

export const fetchCredits = async (type, id) => {
  try {
    const response = await fetch(`${baseUrl}/${type}/${id}/credits?api_key=${apiKey}&language=en-US`);
    if (!response.ok) throw new Error('Failed to fetch credits');
    return await response.json();
  } catch (error) {
    console.error('Error fetching credits:', error);
    return { cast: [] };
  }
};

export const fetchVideos = async (type, id) => {
  try {
    const response = await fetch(`${baseUrl}/${type}/${id}/videos?api_key=${apiKey}&language=en-US`);
    if (!response.ok) throw new Error('Failed to fetch videos');
    return await response.json();
  } catch (error) {
    console.error('Error fetching videos:', error);
    return { results: [] };
  }
};

export const fetchSeasonDetails = async (seriesId, seasonNumber) => {
  try {
    const response = await fetch(`${baseUrl}/tv/${seriesId}/season/${seasonNumber}?api_key=${apiKey}&language=en-US`);
    if (!response.ok) throw new Error('Failed to fetch season details');
    return await response.json();
  } catch (error) {
    console.error('Error fetching season details:', error);
    return null;
  }
};

export const fetchSeriesDetails = async (seriesId) => {
  try {
    const response = await fetch(`${baseUrl}/tv/${seriesId}?api_key=${apiKey}&language=en-US`);
    if (!response.ok) throw new Error('Failed to fetch series details');
    return await response.json();
  } catch (error) {
    console.error('Error fetching series details:', error);
    return null;
  }
};

export const fetchPersonCredits = async (personId) => {
  try {
    const response = await fetch(
      `${baseUrl}/person/${personId}/combined_credits?api_key=${apiKey}&language=en-US`
    );
    if (!response.ok) throw new Error('Failed to fetch person credits');
    return await response.json();
  } catch (error) {
    console.error('Error fetching person credits:', error);
    return { cast: [] };
  }
};

// ===== PROVIDER DETAILS =====
export const fetchProviderDetails = async (providerId) => {
  try {
    const response = await fetch(
      `${baseUrl}/watch/providers/movie?api_key=${apiKey}&watch_region=US`
    );
    if (!response.ok) throw new Error('Failed to fetch providers');
    const data = await response.json();
    const provider = data.results.find(p => p.provider_id === providerId);
    if (provider) {
      return {
        logo_path: provider.logo_path,
        provider_name: provider.provider_name,
      };
    }
    return null;
  } catch (error) {
    console.error('Error fetching provider details:', error);
    return null;
  }
};

export const discoverMovies = async (page = 1, filters = {}, { signal } = {}) => {
  try {
    const { genre, language, year, sort, provider, isCustomLanguage } = filters;
    let url = `${baseUrl}/discover/movie?api_key=${apiKey}&page=${page}`;

    if (sort) {
      if (sort === 'everything') {
        url += '&sort_by=popularity.desc&vote_count.gte=130&vote_count.lte=450&vote_average.gte=5.0';
      } else {
        url += `&sort_by=${sort}`;
        if (sort === 'vote_average.desc') {
          url = url.replace('sort_by=vote_average.desc', 'sort_by=popularity.desc');
          if (isCustomLanguage) {
            url += '&vote_count.gte=150&vote_average.gte=7.0';
          } else {
            url += '&vote_count.gte=550&vote_average.gte=7.0';
          }
        }
        if (sort === 'popularity.desc') {
          if (isCustomLanguage) {
            url += '&vote_count.gte=20';
          } else {
            url += '&vote_count.gte=200';
          }
        }
        if (sort === 'revenue.desc') {
          if (isCustomLanguage) {
            url += '&vote_count.gte=100';
          } else {
            url += '&vote_count.gte=495';
          }
        }
      }
    }

    if ((sort === 'everything' || sort === 'vote_average.desc') && !genre) {
      url += '&without_genres=10402,99';
    }

    if (!language) {
      url += '&without_original_language=hi';
    }

    if (provider) {
      url += `&watch_region=US&with_watch_providers=${provider}`;
    }

    if (genre) url += `&with_genres=${genre}`;
    if (language) url += `&with_original_language=${language}`;
    if (year) {
      if (year === '<1989') url += '&primary_release_date.lte=1989-01-01';
      else if (year === '1990-1999') url += '&primary_release_date.gte=1990-01-01&primary_release_date.lte=1999-12-31';
      else if (year === '2000-2009') url += '&primary_release_date.gte=2000-01-01&primary_release_date.lte=2009-12-31';
      else if (year === '2010-2019') url += '&primary_release_date.gte=2010-01-01&primary_release_date.lte=2019-12-31';
      else if (year === '2020-present') url += '&primary_release_date.gte=2020-01-01';
    } else if (sort === 'everything') {
      const now = new Date();
      const twoMonthsAgo = new Date(now);
      twoMonthsAgo.setMonth(now.getMonth() - 2);
      const lteDate = twoMonthsAgo.toISOString().split('T')[0];
      url += `&primary_release_date.gte=2005-01-01&primary_release_date.lte=${lteDate}`;
    }

    if (genre && genre.includes('99')) {
      if (!url.includes('without_genres')) {
        url += '&without_genres=10402';
      } else {
        url += ',10402';
      }
    }

    const response = await fetch(url, { signal });
    if (!response.ok) throw new Error('Failed to discover movies');
    return await response.json();
  } catch (error) {
    if (error.name === 'AbortError') throw error;
    console.error('Error discovering movies:', error);
    return { results: [], total_pages: 1 };
  }
};

export const discoverSeries = async (page = 1, filters = {}, { signal } = {}) => {
  try {
    const { genre, language, year, sort, provider, isCustomLanguage } = filters;
    let url = `${baseUrl}/discover/tv?api_key=${apiKey}&page=${page}`;

    let withoutGenres = '10763,10767';
    if (!genre) {
      withoutGenres += ',16,99,10764,10402';
    } else if (genre.includes('99')) {
      withoutGenres += ',10402';
    }
    url += `&without_genres=${withoutGenres}`;

    if (provider) {
      url += `&watch_region=US&with_watch_providers=${provider}`;
    }

    if (sort) {
      url += `&sort_by=${sort}`;

      if (sort === 'vote_average.desc') {
        url = url.replace('sort_by=vote_average.desc', 'sort_by=popularity.desc');
        if (isCustomLanguage) {
          url += '&vote_count.gte=200&vote_average.gte=7.5';
        } else {
          url += '&vote_count.gte=1500&vote_average.gte=7.5';
        }
      }
      if (sort === 'popularity.desc') {
        if (isCustomLanguage) {
          url += '&vote_count.gte=50';
        } else {
          url += '&vote_count.gte=152';
        }
      }
      if (sort === 'vote_count.desc') {
        if (isCustomLanguage) {
          url += '&vote_count.gte=100';
        } else {
          url += '&vote_count.gte=500';
        }
      }
      if (sort === 'lesser_known') {
        url = url.replace('sort_by=lesser_known', 'sort_by=popularity.desc');
        if (isCustomLanguage) {
          url += '&vote_count.gte=50&vote_count.lte=400&vote_average.gte=6.0';
        } else {
          url += '&vote_count.gte=300&vote_count.lte=815&vote_average.gte=6.0';
        }
      }
    }

    if (genre) url += `&with_genres=${genre}`;
    if (language) url += `&with_original_language=${language}`;
    if (year) {
      if (year === '<1989') url += '&first_air_date.lte=1989-01-01';
      else if (year === '1990-1999') url += '&first_air_date.gte=1990-01-01&first_air_date.lte=1999-12-31';
      else if (year === '2000-2009') url += '&first_air_date.gte=2000-01-01&first_air_date.lte=2009-12-31';
      else if (year === '2010-2019') url += '&first_air_date.gte=2010-01-01&first_air_date.lte=2019-12-31';
      else if (year === '2020-present') url += '&first_air_date.gte=2020-01-01';
    }

    const response = await fetch(url, { signal });
    if (!response.ok) throw new Error('Failed to discover series');
    return await response.json();
  } catch (error) {
    if (error.name === 'AbortError') throw error;
    console.error('Error discovering series:', error);
    return { results: [], total_pages: 1 };
  }
};